import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Navbar from '../../../../components/navbar';
import Footer from '../../../../components/footer';
import Button from '../../../../components/Button';
import { useConsultation } from '../../../../context/ConsultationContext';
import { handleTreatmentServiceNavigation } from '../components/treatmentNavigationHelper';
import styles from './css/BloodPressure.module.css';
import newStyles from './css/Lipogram.module.css';
import { Send, ChartNoAxesColumn } from 'lucide-react';

const Lipogram = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { consultationData, updateConsultationData, getStepDraft, setStepDraft, goToStep } = useConsultation();

    const patient = location?.state?.patient || consultationData?.patient || {};
    const patientName = `${patient?.firstname || ""} ${patient?.surname || ""}`.trim() || "Thandiwe Ndlovu";
    const profileNumber = patient?.profilenumber || "448896";
    const initials = `${patient?.firstname?.[0] || ""}${patient?.surname?.[0] || ""}`.toUpperCase() || "TN";

    const [hdl, setHdl] = useState('');
    const [ldl, setLdl] = useState('');
    const [triglycerides, setTriglycerides] = useState('');
    const [clinicalNotes, setClinicalNotes] = useState('');

    const handleInvoice = () => {
        handleTreatmentServiceNavigation({
            location,
            navigate,
            consultationData,
            updateConsultationData,
            getStepDraft,
            setStepDraft,
            goToStep,
            serviceData: {
                lipogram_test: {
                    hdl,
                    ldl,
                    triglycerides,
                    clinicalNotes,
                },
            },
        });
    };

    useEffect(() => {
        document.body.classList.add(styles.hideSidebar);
        return () => {
            document.body.classList.remove(styles.hideSidebar);
        };
    }, []);

    return (
        <div className={styles.bloodPressureContainer}>
            <Navbar />

            <main className={styles.mainContent}>
                <div className={styles.card}>
                    <div className={styles.cardHeader}>
                        <div className={styles.headerIcon} aria-hidden="true">
                            <ChartNoAxesColumn />
                        </div>
                        <h1 className={newStyles.title}>Lipogram Test</h1>
                    </div>

                    <div className={styles.patientCard}>
                        <div className={styles.avatar} aria-hidden="true">{initials}</div>
                        <div className={styles.patientText}>
                            <div className={styles.patientName}>{patientName}</div>
                            <div className={styles.patientMetaRow}>
                                <span className={styles.profileInfo}>Profile: {profileNumber}</span>
                                <span className={styles.dependentBadge}>Dependent</span>
                            </div>
                        </div>
                    </div>

                    <div className={styles.sectionBlock}>
                        <div className={styles.sectionTitle}>LIPID PANEL</div>
                        <div className={styles.readingsRow}>
                            <div className={styles.readingItem}>
                                <label className={styles.readingLabel}>HDL</label>
                                <div className={styles.inputGroup}>
                                    <input
                                        type="number"
                                        value={hdl}
                                        onChange={(e) => setHdl(e.target.value)}
                                        className={styles.readingInput}
                                        placeholder='—'
                                    />
                                    <span className={styles.unit}>mmol/L</span>
                                </div>
                            </div>

                            <div className={styles.readingItem}>
                                <label className={styles.readingLabel}>LDL</label>
                                <div className={styles.inputGroup}>
                                    <input
                                        type="number"
                                        value={ldl}
                                        onChange={(e) => setLdl(e.target.value)}
                                        className={styles.readingInput}
                                        placeholder='—'
                                    />
                                    <span className={styles.unit}>mmol/L</span>
                                </div>
                            </div>

                            <div className={styles.readingItem}>
                                <label className={styles.readingLabel}>Triglycerides</label>
                                <div className={styles.inputGroup}>
                                    <input
                                        type="number"
                                        value={triglycerides}
                                        onChange={(e) => setTriglycerides(e.target.value)}
                                        className={styles.readingInput}
                                        placeholder='—'
                                    />
                                    <span className={styles.unit}>mmol/L</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={styles.sectionBlock}>
                        <div className={styles.fieldLabel}>Clinical Notes</div>
                        <textarea
                            value={clinicalNotes}
                            onChange={(e) => setClinicalNotes(e.target.value)}
                            className={styles.clinicalNotes}
                            placeholder="Enter clinical notes..."
                            rows={6}
                        />
                    </div>

                    <div className={styles.cardFooter}>
                        <Button
                            onClick={handleInvoice}
                            className={styles.invoiceButton}
                            type="button"
                        >
                            <Send size={16} />
                            Invoice
                        </Button>
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    );
};

export default Lipogram;